angular.module('gym.users').controller('InviteUserCtrl', ["$scope", "$rootScope", "GTMService", "AdminUserService", function($scope, $rootScope, GTMService, AdminUserService) {
  GTMService.trackPage('Users', 'Invite new User');
  $scope.adminHasPermission = AdminUserService.has;
  return $scope.gym = $rootScope.gym;
}]);
